export default {
  status: "",
  mailHandler: "",
  rank: 0,
  token: "",
}